module.exports = __webpack_public_path__ + "img/yj_share_guide1.13caaeab.png";